import type { Signal } from '@preact/signals-react'
import { signal } from '@preact/signals-react'
import type { Availability } from '@susu/headless-commerce/features/configurator/domain/Availability/Availability'
import log from '@susu/headless-commerce/utils/log'

export type Image = {
  breakpoint: string
  srcset: string
  url: string
}

export class Product {
  availability: Signal<Availability>
  badge: Signal<string | undefined>
  categoryId: Signal<string | undefined>
  categoryName: Signal<string | undefined>
  code: Signal<string | undefined>
  colorId: Signal<string | undefined>
  currency: Signal<string | undefined>
  desktopImage: Signal<Image>
  enabledInLookBuilder: Signal<boolean | undefined>
  fabricCodeID: Signal<string | undefined>
  fitId: Signal<string>
  id: Signal<string | null | undefined>
  isCustomMadeProduct: Signal<string | undefined>
  isEnabledCustomizeButton: Signal<boolean | undefined>
  isFabricAvailable: Signal<boolean | undefined>
  materialValue: Signal<string>
  mobileImage: Signal<Image>
  name: Signal<string>
  nameInEnglish: Signal<string>
  onlineMaterial: Signal<string>
  price: Signal<number>
  size: Signal<string | undefined>
  sizeId: Signal<string | undefined>
  style: Signal<string | undefined>
  styleId: Signal<string | undefined>
  type: Signal<string>
  url: Signal<string>

  constructor(
    availability: Availability,
    badge: string | undefined,
    categoryId: string | undefined,
    categoryName: string | undefined,
    code: string | undefined,
    colorId: string | undefined,
    currency: string | undefined,
    desktopImage: Image,
    enabledInLookBuilder: boolean | undefined,
    fabricCodeID: string | undefined,
    fitId: string,
    id: string | null | undefined,
    isCustomMadeProduct: string | undefined,
    isEnabledCustomizeButton: boolean | undefined,
    isFabricAvailable: boolean | undefined,
    materialValue: string,
    mobileImage: Image,
    name: string,
    nameInEnglish: string,
    onlineMaterial: string,
    price: number,
    size: string | undefined,
    sizeId: string | undefined,
    style: string | undefined,
    styleId: string | undefined,
    type: string,
    url: string,
  ) {
    this.availability = signal(availability)
    this.badge = signal(badge)
    this.categoryId = signal(categoryId)
    this.categoryName = signal(categoryName)
    this.code = signal(code)
    this.colorId = signal(colorId)
    this.currency = signal(currency)
    this.desktopImage = signal(desktopImage)
    this.enabledInLookBuilder = signal(enabledInLookBuilder)
    this.fabricCodeID = signal(fabricCodeID)
    this.fitId = signal(fitId)
    this.id = signal(id)
    this.isCustomMadeProduct = signal(isCustomMadeProduct)
    this.isEnabledCustomizeButton = signal(isEnabledCustomizeButton)
    this.isFabricAvailable = signal(isFabricAvailable)
    this.materialValue = signal(materialValue)
    this.mobileImage = signal(mobileImage)
    this.name = signal(name)
    this.nameInEnglish = signal(nameInEnglish)
    this.onlineMaterial = signal(onlineMaterial)
    this.price = signal(price)
    this.size = signal(size)
    this.sizeId = signal(sizeId)
    this.style = signal(style)
    this.styleId = signal(styleId)
    this.type = signal(type)
    this.url = signal(url)

    log.debug({
      method: 'Product.constructor',
      // availability,
      // badge,
      // categoryId,
      // categoryName,
      // code,
      // colorId,
      // currency,
      // desktopImage,
      // enabledInLookBuilder,
      // fabricCodeID,
      // fitId,
      id,
      // isCustomMadeProduct,
      // isEnabledCustomizeButton,
      // isFabricAvailable,
      // materialValue,
      // mobileImage,
      name,
      nameInEnglish,
      // onlineMaterial,
      // price,
      // size,
      // sizeId,
      // style,
      // styleId,
      // type,
      // url,
    })
  }
}
